/* eslint-disable react-hooks/exhaustive-deps */
import { LoadingOutlined } from '@ant-design/icons';
import { Input, Spin } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../../constants/service.types';
import { socketEmitEvent } from '../../../redux/actions';
import { HistoryEventsModal } from '../HistoryEventsModal';
import { ServicesModal } from '../ServicesModal';
import './Menu.scss';
import MenuItemCamera from './MenuItemCamera';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import DndCamera from '../DndCamera';
import { MODE_CAMERA } from '../../../constants';
import { useTranslation } from 'react-i18next';

const { Search } = Input;

const TreeCamera = ({
  setSelect,
  owner,
  handleUpdateStream,
  handleRemoveDevice,
  handleUpdateCamera,
  total,
  onCreateGroup,
  setVisibleAdd,
  setDataArr,
  setIdParentCameraGroup,
  cameraGroup1,
  checkData,
  current,
  // mode = 'camera' or 'live',
  mode = MODE_CAMERA,
  setTimeRequest,
  pinCamera,
  pinnedCamera,
  unpinCamera,
}) => {
  const { t } = useTranslation();
  const {
    namespace,
    listDeviceGroups,
    loadingGetListDevice,
    listDeviceGroupByPage,
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [listDeviceGroupsData, setListDeviceGroupsData] = useState(null);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [idParentSelected, setIdParentSelected] = useState(null);
  const [idLiveSelected, setIdLiveSelected] = useState(null);
  const [checkLoading, setCheckLoading] = useState(false);
  const [isVisibleHistoryEvent, setIsVisibleHistoryEvent] = useState(false);
  const [isVisibleServices, setIsVisibleServices] = useState(false);
  const [dataCameraHistoryEvent, setDataCameraHistoryEvent] = useState(null);
  const [dataCameraService, setDataCameraService] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);

  const fetchListDeviceGroupByParentDeviceGroup = (parentDeviceGroupId) => {
    const dataTimeRequest = new Date().getTime();
    const data = {
      namespace,
      parentDeviceGroupId: parentDeviceGroupId,
    };
    let dataObj = {
      appServiceType: SERVICE.LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP,
      requestId: dataTimeRequest,
      body: JSON.stringify(data),
    };

    dispatch(socketEmitEvent(dataObj));
  };
  const getPaginationOptionData = useCallback(
    (value) => {
      dispatch(
        socketEmitEvent({
          appServiceType: SERVICE.LIST_DEVICE_GROUP_BY_PAGE_V2,
          requestId: new Date().getTime(),
          body: JSON.stringify({
            namespace,
            name: value,
            page: 0,
            size: 9999,
            timeRequest: new Date().getTime(),
          }),
        })
      );
    },
    [dispatch, namespace]
  );
  const onSearchCamera = (name) => {
    setSearchValue(name?.trim());
    getPaginationOptionData(name?.trim());
  };

  useEffect(() => {
    fetchListDeviceGroupByParentDeviceGroup(-1);
    if (setIdParentCameraGroup) {
      setIdParentCameraGroup(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (idParentSelected && setIdParentCameraGroup) {
      setIdParentCameraGroup(idParentSelected);
    } else {
      if (setIdParentCameraGroup) {
        setIdParentCameraGroup(-1);
      }
    }
  }, [idParentSelected]);

  useEffect(() => {
    if (
      listDeviceGroups &&
      listDeviceGroups?.[0]?.parentDeviceGroupId === -1 &&
      !searchValue
    ) {
      setListDeviceGroupsData(listDeviceGroups || []);
    }
  }, [listDeviceGroups]);

  useEffect(() => {
    setListDeviceGroupsData(listDeviceGroupByPage?.deviceGroups || []);
  }, [listDeviceGroupByPage]);
  useEffect(() => {
    const treeCameraElement = document.querySelector('.tree-camera');
    if (treeCameraElement) {
      const observer = new MutationObserver((mutations) => {
        const hasScroll =
          treeCameraElement.scrollHeight > treeCameraElement.clientHeight;
        if (hasScroll) {
          treeCameraElement.style.paddingRight = '8px';
        } else {
          treeCameraElement.style.paddingRight = '0px';
        }
      });

      observer.observe(treeCameraElement, { childList: true, subtree: true });

      // Cleanup
      return () => observer.disconnect();
    }
  }, []);
  return (
    <>
      <div
        className="search-camera"
        style={{ marginBottom: '8px', display: 'flex' }}
      >
        <Search
          placeholder={t('Search group')}
          onSearch={onSearchCamera}
          allowClear
        />
      </div>
      {checkData !== 0 && cameraGroup1 ? (
        <div
          className="main-pinned-component"
          style={{
            height: 'calc(100vh - 200px)',
            display: checkData === 0 ? 'none' : 'block',
          }}
        >
          <DndProvider backend={HTML5Backend}>
            <DndCamera
              setSelect={setSelect}
              current={current}
              data={cameraGroup1 && cameraGroup1.devices}
              owner={owner}
              handleUpdateCamera={handleUpdateCamera}
              handleUpdateStream={handleUpdateStream}
              handleRemoveDevice={handleRemoveDevice}
            />
          </DndProvider>
        </div>
      ) : (
        <Spin
          spinning={loadingGetListDevice && checkLoading}
          indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />}
        >
          <ul className="tree-camera">
            {listDeviceGroupsData &&
              listDeviceGroupsData.map((item) => (
                <MenuItemCamera
                  key={item.id}
                  id={item.id}
                  {...item}
                  camera={item}
                  setSelectedCamera={setSelectedCamera}
                  selectedCamera={selectedCamera}
                  setSelect={setSelect}
                  owner={owner}
                  handleUpdateStream={handleUpdateStream}
                  handleRemoveDevice={handleRemoveDevice}
                  handleUpdateCamera={handleUpdateCamera}
                  idParentSelected={idParentSelected}
                  setIdParentSelected={setIdParentSelected}
                  setCheckLoading={setCheckLoading}
                  total={total}
                  onCreateGroup={onCreateGroup}
                  setVisibleAdd={setVisibleAdd}
                  setDataArr={setDataArr}
                  //For visible popup
                  setIsVisibleHistoryEvent={setIsVisibleHistoryEvent}
                  setIsVisibleServices={setIsVisibleServices}
                  setDataCameraHistoryEvent={setDataCameraHistoryEvent}
                  setDataCameraService={setDataCameraService}
                  mode={mode}
                  setTimeRequest={setTimeRequest}
                  pinCamera={pinCamera}
                  pinnedCamera={pinnedCamera}
                  unpinCamera={unpinCamera}
                  idLiveSelected={idLiveSelected}
                  setIdLiveSelected={setIdLiveSelected}
                  isExpanded={isExpanded}
                  setIsExpanded={setIsExpanded}
                  listDeviceGroupsData={listDeviceGroupsData}
                  refreshData={fetchListDeviceGroupByParentDeviceGroup}
                  current={current}
                />
              ))}
          </ul>
        </Spin>
      )}
      <HistoryEventsModal
        title={dataCameraHistoryEvent?.name}
        data={dataCameraHistoryEvent}
        isModalVisible={isVisibleHistoryEvent}
        handleOk={() => setIsVisibleHistoryEvent(false)}
        handleCancel={() => setIsVisibleHistoryEvent(false)}
      />
      <ServicesModal
        title={dataCameraService?.name}
        isVisible={isVisibleServices}
        handleOk={() => setIsVisibleServices(false)}
        handleCancel={() => setIsVisibleServices(false)}
        data={dataCameraService}
      />
    </>
  );
};

export default React.memo(TreeCamera);
